import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { InputSelect } from '../../../../Select'
import {
  QA_NAME_VIEWING_FORM_DURATION,
  VIEWING_FORM_FIELD_NAME,
} from '../../RentalPortalViewingFormModal.constants'
import { toViewingFormDurationOptions } from '../../RentalPortalViewingFormModal.utils'

function ViewingFormDurationField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Select={InputSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('RentalPortal.ViewingFormDurationPlaceholderKey'),
          },
        },
      }}
      emptyValue={null}
      fieldComponentProps={{
        label: `${t('RentalPortal.ViewingFormDurationLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={VIEWING_FORM_FIELD_NAME.duration}
      options={toViewingFormDurationOptions(t)}
      qaName={QA_NAME_VIEWING_FORM_DURATION}
    />
  )
}

export default ViewingFormDurationField
